import { ref, onMounted, onUnmounted } from 'vue';
import { checkForNewVersion, updateStoredVersion } from '@/utils/versionCheck';

export function useVersionCheck() {
	const showUpdateModal = ref(false);
	let intervalId: number | undefined;
	const reload = () => window.location.reload();

	onMounted(async () => {
		try {
			// Initial check
			const hasNew = await checkForNewVersion();
			if (hasNew) showUpdateModal.value = true;

			// Then start interval
			intervalId = window.setInterval(async () => {
				try {
					const hasNew = await checkForNewVersion();
					if (hasNew) showUpdateModal.value = true;
				} catch (error) {
					console.error('Error checking for new version:', error);
				}
			}, 60000);
		} catch (error) {
			console.error('Error in initial version check:', error);
		}
	});

	onUnmounted(() => {
		if (intervalId) clearInterval(intervalId);
	});

	return { showUpdateModal, reload };
}
